import React from 'react';
import { motion } from 'framer-motion';
import Button from '../ui/Button';

interface LegalNoticeModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const LegalNoticeModal: React.FC<LegalNoticeModalProps> = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center z-50 p-4">
      <motion.div
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{ opacity: 1, scale: 1 }}
        exit={{ opacity: 0, scale: 0.9 }}
        className="bg-white dark:bg-gray-800 rounded-2xl shadow-2xl max-w-4xl w-full max-h-[90vh] overflow-hidden"
      >
        {/* Header */}
        <div className="p-6 border-b border-gray-200 dark:border-gray-700">
          <div className="flex justify-between items-center">
            <h2 className="text-2xl font-bold text-gray-900 dark:text-white">
              Legal Notice
            </h2>
            <button
              onClick={onClose}
              aria-label="Close"
              className="text-gray-400 hover:text-gray-600 dark:hover:text-gray-300 text-2xl"
            >
              ×
            </button>
          </div>
        </div>

        {/* Body */}
        <div className="p-6 overflow-y-auto max-h-[70vh] custom-scrollbar">
          <div className="prose dark:prose-invert max-w-none text-sm">
            <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-3">
              Trademark and Brand Notice
            </h3>
            <p className="text-gray-600 dark:text-gray-400 mb-4">
              Scentral is an independent fragrance collection and wishlist management platform
              created for fragrance enthusiasts.
            </p>

            <p className="text-gray-600 dark:text-gray-400 mb-4">
              All product names, brands, and trademarks referenced within Scentral are the property
              of their respective owners. Their inclusion is for{' '}
              <strong>identification and reference purposes only</strong>, in accordance with{' '}
              <em>nominative fair use</em> principles under applicable trademark laws.
            </p>

            <p className="text-gray-600 dark:text-gray-400 mb-4">
              Scentral is <strong>not affiliated with, endorsed by, or sponsored by</strong> any
              perfume house, manufacturer, or retailer mentioned by users.
            </p>

            <p className="text-gray-600 dark:text-gray-400 mb-4">
                Users may log, organize, and share information about fragrances in their personal
                collections for non-commercial use. Scentral does not sell or distribute brand
                materials, copyrighted imagery, or marketing content, and disclaims any liability
                for user-submitted content.
            </p>

            <p className="text-gray-600 dark:text-gray-400">
              If you are a rights holder and have concerns about how your brand or products are
              represented, please contact{' '}
              <a
                href="mailto:support@scentral.app"
                className="text-blue-600 hover:text-blue-700 dark:text-blue-400 underline"
              >
                support@scentral.app
              </a>{' '}
              — we respect all intellectual property rights and will address any valid requests
              promptly.
            </p>
          </div>
        </div>

        {/* Footer */}
        <div className="p-6 border-t border-gray-200 dark:border-gray-700">
          <div className="flex justify-center">
            <Button onClick={onClose}>I Understand</Button>
          </div>
        </div>
      </motion.div>
    </div>
  );
};

export default LegalNoticeModal;